<script>
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import CustomLinkImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/CustomLinkImageElement.vue";
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";

export default {
  name: "AuthorAvatar",
  extends: CustomLinkImageElement,
  mixins: [BaseStoryCardElementMixin],
  elementPanelSettings: {
    displayName: "Author Avatar",
    displayIcon: "image",
    elementType: "element",
    elementGroup: "storyElements",
  },
  options: [
    StoryCardClickBehavior,
  ],
  computed: {
    imageHref() {
      return this.storyHref;
    },
    imageSrc() {
      let imageUrl = this.entity.authorAvatar;
      if (imageUrl === "") {
        imageUrl = this.getOptionValue(this.FallbackImage);
      }
      if (imageUrl === "") {
        imageUrl = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/avatar-default.png";
      }
      return imageUrl;
    },
  },
};
</script>
